module.exports = __webpack_public_path__ + "static/media/undraw_design_notes_8dmv.b8db496b.svg";